export const PAYMENT_TYPES = {
  PARTICULAR: 'PARTICULAR',
  B2B: 'B2B',
  HEALTH_INSURANCE: 'HEALTH_INSURANCE'
};

export type PaymentValidationRule = {
  type: string;
  additional_info?: {
    plan_code: string;
  };
};

export function PaymentValidation(paymentValidation: PaymentValidationRule) {
  return paymentValidation;
}
